import React, {ReactElement} from "react"

const LeftArrowIcon = (): ReactElement => {
	return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0833 5.75H0.75M0.75 5.75L5.75 10.75M0.75 5.75L5.75 0.75"
        stroke= "currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </svg>

  )
}

export default LeftArrowIcon
